import context from "@/core/context"
import settings from "./settings"
import windows from "./windows"

let loaded = false

export function isLoaded() {
  return loaded
}

export async function load() {
  if (loaded) {
    return
  }
  const { document } = windows.site
  // NOTE use zz instead of z, since z works only if it is the MD5 hash of the resource
  const url = `${settings.server}/assets/public/jsbuild/toolbar/debugtoolbar.min.js?zz=!CACHEVALUE!`
  const scriptElement = document.createElement("script")
  scriptElement.src = url
  scriptElement.type = "module"
  document.head.prepend(scriptElement)
  loaded = true
}

export async function initToolbar() {
  if (context.mode.isDebug()) {
    await load()
  }
}
